import React from "react";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import "./../styles/global.css";
import erphero from "../images/erphero.png"
import building from "../images/buildin.jpg"
import why_erp from "../images/why_erp.webp"
import imgdiv1 from "../images/imgdiv1.jpeg"
import drona from "../images/drona.webp"
import anamika from "../images/anamika.webp"
import pdhawan from "../images/pdhawan.jpg";
import vkumar from "../images/vkumar.jpg";
import jaya from "../images/jaya.jpg"

import Footer from "../components/Footer.js"


const teamMembers = [
  { name: "CM GUPTA", role: "HEAD DEVELOPER", location: "BANGLORE", image:imgdiv1 },
  { name: "P DHAWAN", role: "HEAD FINANCE", location: "FUNCTIONAL", image: pdhawan},
  { name: "DRONA SHARMA", role: "RAIPUR", location: "", image: drona },
  { name: "V KUMAR", role: "HEAD HR", location: "FUNCTIONAL", image: vkumar },
  { name: "ANAMIKA SHARMA", role: "HEAD RECRUITMENT", location: "", image: anamika},
  { name: "K SHAHU", role: "HEAD IR", location: "", image: imgdiv1},
  { name: "SADASHIV VERMA", role: "INDORE", location: "", image: pdhawan},
  { name: "JAYA G", role: "BHOPAL", location: "", image: jaya},
  
];

const Home = () => {


  // YE MERA SLIDER BALA CODE H============================

  const [currentIndex, setCurrentIndex] = useState(0);
  const [hover, setHover] = useState(false);
  const itemsPerSlide = window.innerWidth < 768 ? 2 : 4; // Mobile: 2 items, Desktop: 4 items

  useEffect(() => {
    if (!hover) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + itemsPerSlide) % teamMembers.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [hover, itemsPerSlide]);
  
  return (
    <>
    
    <motion.div
      className="hero-section"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1>Welcome to ERP Solutions </h1>
      <h3 className="up_hero_h3">Your one-step solution for Enterprise Management</h3>
    {/* hero section */}
      <img src={erphero} alt="ERP Banner" className="hero-image" />
      {/* end hero section */}

      {/* ============= new section ====================== */}
    
      {/* New Section */}
    <div className="our_solution">
      <div className="right-part">

    <h2 className="OUR_SOLUTION_H1">OUR<br></br> SOLUTIONS</h2>
    <p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MANUFACTURING</p>
    <p> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BATCH PRACTICES</p>
    <p>PROJECTS</p>
    </div>

    <div className="left_part">
      <div className="left-part-text">
  <h3>WHO WE
    <br></br> ARE</h3>
  <p>A TEAM OF ENGINEER AND IT
     PROFESSIONALS WHO AIM TO
    PROVIDE THE BEST SOLUTIONS
    IN ERP AND BECOME THE BEST
    FROM THE REST....
  </p>
      </div>
      <img className="building" src={building} alt="bilding img"></img>

    </div>
    </div>

    {/* ========== hero section ke nche ke niche ka section ===== why we are ======= */}

    <div className="why_we">

<div className="why-we-left">
  <img className="erp-img" src={why_erp} alt="erp image"></img>
  
  
</div>
    
    <div className="why-we-right">
    <h3>KNEWX ERP SOLUTIONS</h3>
  <h5>BECAUSE WE PROVIDE...</h5>
  <p>KnewX ERP simplifies business management by integrating finance,
     HR, inventory, and customer operations into a seamless, automated
  system. With real-time analytics, cloud security, and scalable features,
  it enhances productivity and decision-making. Stay ahead 
    of the competition with a smarter, more efficient, and fully connected business solution</p>
 
    </div>
    </div>
    {/* =========================  team intro part ================================ */}
    <h3 className="h3"> MEET OUR TEAM</h3>
    <div className="Intro">
  <div className="slider-container">
    {teamMembers.slice(currentIndex, currentIndex + itemsPerSlide).map((member, index) => (
      <div className="Intro-div1" key={index}>
        <img src={member.image} alt={member.name} />
        <h4>{member.name}</h4>
        <p className="intro-p">
          {member.role} <br /> {member.location}
        </p>
      </div>
    ))}
  </div>
</div>

    
      
    
      {/* Dots Navigation */}
    <div className="dots-container">
        {Array.from({ length: Math.ceil(teamMembers.length / itemsPerSlide) }).map((_, index) => (
          <span
            key={index}
            className={index === Math.floor(currentIndex / itemsPerSlide) ? "dot active" : "dot"}
            onClick={() => setCurrentIndex(index * itemsPerSlide)}
          ></span>
        ))}
      </div>
    {/* =================== end part of introduction ================================================= */}
    </motion.div>
    <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
    <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
    <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
    <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
    <Footer/>
    </>
  );
};

export default Home;



